import moment from 'moment'
import {injectableClass} from '../utils/Utils'

@injectableClass("webtrader", "Account", "$http")
export class Quote {
  constructor(data) {
    this.update(data)
    this.short_symbol = this.symbol.replace(/_OP$/, "")
    this.short_symbol = this.symbol.replace(/e$/, "")
    this.power = Math.pow(10, this.digits)
  }

  get isMetal() {
    return ["SILVER", "GOLD"].includes(this.short_symbol)
  }

  get isPair() {
    return this.short_symbol.length == 6 // close enough
  }

  update(data) {
    this.direction = data.direction || this.bid > data.bid
    _.extend(this, data)

    this.time = moment.unix(this.time)

    if (this.bid) {
      let bidParts = this.bid.toFixed(this.digits).toString().match(/(.*?)(\d{0,2})(\d{0,1})$/)
      this.bid_start = bidParts.slice(-3, -2)[0]
      this.bid_middle = bidParts.slice(-2, -1)[0]
      this.bid_end = bidParts.slice(-1)[0]
      this.bid_display = this.bid.toFixed(this.digits)
    }

    if (this.ask) {
      let askParts = this.ask.toFixed(this.digits).toString().match(/(.*?)(\d{0,2})(\d{0,1})$/)
      this.ask_start = askParts.slice(-3, -2)[0]
      this.ask_middle = askParts.slice(-2, -1)[0]
      this.ask_end = askParts.slice(-1)[0]
      this.ask_display = this.ask.toFixed(this.digits)
    }
  }

  getTradingStats() {
    return this.constructor.$http.get(`${this.constructor.Account.BASE_URL}/trade/global_stats/`, {
      params: {
        symbol: this.symbol
      }
    })
  }

  get profitFormula() {
    return PROFIT_FORMULAS[this.profit_mode]
  }
}


let PROFIT_FORMULAS = [
  //forex
  (trade) => {
    return (trade.close_price - trade.open_price) * trade.quote.contract_size * trade.volume
  },
  //cfd
  (trade) => {
    return (trade.close_price - trade.open_price) * trade.quote.contract_size * trade.volume
  },
  //futures
  (trade) => {
    return (trade.close_price - trade.open_price) * trade.quote.tick_price / trade.quote.tick_size * trade.volume
  }
]
